<template>
    <div>
        <FundsView :data-set="dataSet"/>
    </div>

</template>
<script setup lang="ts">
import FundsView from '@/themes/themeOne/funds/fundsView.vue';
import { ref,computed} from 'vue'
import { FundViewData } from './fundsView';
const availableBalance = ref(0);
const dataSet = computed<FundViewData>(() => ({
    availableBalance: availableBalance.value
}))

</script>
<style scoped>
.funds_container {
    min-height: 100vh;
    padding: 0rem 1rem;
}

.weekly-banner {
    max-width: 100%;
    margin: 0 auto;
    position: relative;
}

.weekly-img {
    width: 100%;
    height: auto;
    display: block;
    position: absolute;
}

.activity-title-row {
    display: flex;
    align-items: center;
    margin: 5vh 0vh 0vh;
}

.detail-table {
    display: flex;
    align-items: center;
    margin: 8vh 0vh 0vh;
}

.left-img {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-right: 0.2rem;
}

.activity-title {
    color: #FFFFFFD9;
    font-size: 15px;
    display: flex;
    justify-content: center
}

.right-img {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-left: 0.2rem;
}

.activity-text {
    color: #FFFFFF73;
    font-size: 14px;
    margin: 10px 0px;
    line-height: 20px;
}

.top-box {
    padding: 24px 0px;
    position: relative;
    padding-top: 27vh;
}

.top-text {
    position: absolute;
    top: 18.9rem;
    left: 33%;
    transform: translate(-50%, -50%);
    color: #FFFFFFA6;
    font-size: 15px;
    white-space: nowrap;
}

.middle-text {
    position: absolute;
    top: 15.3rem;
    left: 33%;
    transform: translate(-50%, -50%);
    color: #FFFFFFA6;
    font-size: 15px;
    white-space: nowrap;
}

.top-profit {
    position: absolute;
    top: 9.2rem;
    left: 32%;
    transform: translate(-50%, -50%);
    color: #00000073;
    font-size: 13px;
}

.top-funds {
    position: absolute;
    top: 15.5rem;
    left: 29%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 19px;
    white-space: nowrap;
}

.middle-funds {
    position: absolute;
    top: 12.1rem;
    left: 29%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 19px;
    white-space: nowrap;
}

.top-amount {
    position: absolute;
    top: 15.5rem;
    left: 85%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 15px;
    white-space: nowrap;
    align-items: center;
    display: flex;
}

.middle-amount {
    position: absolute;
    top: 12.1rem;
    left: 85%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 15px;
    white-space: nowrap;
    align-items: center;
    display: flex;
}

.top-bottom-amount {
    position: absolute;
    top: 20.9rem;
    left: 2.6rem;
    transform: translate(-50%, -50%);
    color: #FFFFFFA6;
    font-size: 15px;
    white-space: nowrap;
    align-items: center;
    display: flex;
}

.middle-bottom-amount {
    position: absolute;
    top: 17.2rem;
    left: 2.6rem;
    transform: translate(-50%, -50%);
    color: #FFFFFFA6;
    font-size: 15px;
    white-space: nowrap;
    align-items: center;
    display: flex;
}

.middle-compensation {
    position: absolute;
    top: 1.9rem;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 13px;
    white-space: nowrap;
}

.middle-date {
    position: absolute;
    top: 3.5rem;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap
}

.middle-available-compensation {
    position: absolute;
    top: 9.1rem;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 15px;
    white-space: nowrap
}

.middle-available-amount {
    position: absolute;
    top: 10.9rem;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFFD9;
    font-size: 17px;
}

.top-card-bg,
.middle-card-bg {
    width: 100%;
    height: auto;
    display: block;
    position: absolute;
}

.funds-card {
    max-width: 100%;
    margin: 0 auto;
    padding-top: 32vh;
    position: relative;
}

.funds-card-middle {
    max-width: 100%;
    margin: 0 auto;
    padding-top: 24vh;
    position: relative;
}

.funds-middle-banner {
    max-width: 100%;
    margin: 0 auto;
    padding-top: 24vh;
    position: relative;
}

.compensation-middle-card {
    max-width: 100%;
    margin: 0 auto;
    padding-top: 0vh;
    position: relative;
}

.from,
.to {
    color: #00000073;
    font-size: 13px;
}

.from-date,
.to-date {
    color: #000;
    font-size: 13px;
}

.top-compensation-amount {
    position: absolute;
    top: 7.1rem;
    left: 88%;
    transform: translate(-50%, -50%);
    color: #00000073;
    font-size: 14px;
}

.top-profit-amount {
    position: absolute;
    top: 9.1rem;
    left: 88%;
    transform: translate(-50%, -50%);
    color: #00000073;
    font-size: 14px;
}

.middle-time-icon {
    position: absolute;
    top: 3.5rem;
    left: 31%;
    transform: translate(-50%, -50%);
    width: 5%;
    filter: invert(100%);
}

.middle-moneybag-icon {
    position: absolute;
    top: 6.8rem;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12%;
}

.exchange-btn {
    background-color: transparent;
    width: 6.1rem;
    height: 3.33rem;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 16.5rem;
    left: 18rem;
    transform: translate(-50%, -50%);
}

.exchange-btn-disabled {
    background-image: url('@/assets/funds/rescuev2_claim_disable.png');
    background-size: contain;
    background-repeat: no-repeat;
}

.exchange-btn-active {
    background-image: url('@/assets/funds/rescuev2_claim_disable.png');
    background-size: contain;
    background-repeat: no-repeat;
}

.table-title {
    background-color: #f5deb32e;
    padding: 8px;
    border-radius: 4px;
    text-align: center;
    padding: 0.7rem 0;
}

.table-row {
    text-align: center;
    padding: 0.7rem 0;
    border-radius: 0.4rem;
}

.light {
    background: #ffffff05;
}

.dark {
    background: #ffffff14;
}

.table-text {
    color: #ffffff73;
    font-size: 15px;
}
</style>